// extracted by mini-css-extract-plugin
export var chevronIcon = "_sm-1";
export var edgeToggle = "_sm-0";